<script>
import _difference from 'lodash/differenceBy'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: [],
      other: '',
      otherIsSelect: false
    }
  },
  computed: {
    hasOther() {
      return this.field.params.options.some(item => {
        return item.optionType === 'text'
      })
    }
  },
  watch: {
    inputData: {
      handler(v, ov) {
        // this.setFromData()
      },
      deep: true
    },
    data: {
      handler(v, ov) {
        this.updataInput();
      },
      deep: true
    },
    other(v) {
      this.otherIsSelect = this.other !== '';
      this.updataInput();
    },
    otherIsSelect(v) {
      this.updataInput();
    },
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    updataInput() {
      const data = typeof this.data === 'string' ? [this.data] : this.data;
      const other = this.otherIsSelect && this.other !== '' ? [this.other] : [];

      this.$nextTick(()=> {
        this.$emit('update:inputData', [
          ...data,
          ...other
        ]);
      })
    },
    setFromData() {
     this.$nextTick(() => {
       this.$nextTick(() => {
         const options = this.field.params.options.map(item => {
           return item.title
         });

         const other = _difference(this.inputData, options);

         this.data = _difference(this.inputData, other);

         if(other.length > 0) {
           this.other = other[0]
         }
       })
      });
    }
  },
  inject: ['$validator'],
}

</script>
<template>
  <b-field
    :message="errors.first(name)"
    :type="{ 'is-danger': errors.has(name) }"
    class="is-style-extrafield"
    :label="`${field.title} (${$t('global.MULTIPLE_SELECTION' /*多選*/)})`"
    :class="{ [$style['isRequired']]: field.required }"
  >
    <template v-for="(fieldOption, index) in field.params.options">
      <b-checkbox
        v-if="fieldOption.optionType === 'default'"
        :key="index"
        v-model="data"
        v-validate="{ required: Boolean(field.required) && !hasOther }"
        :true-value="field.title"
        :false-value="''"
        :data-vv-as="field.title"
        :name="name"
        :native-value="fieldOption.title">
        {{fieldOption.title}}
      </b-checkbox>
      <div
        v-if="fieldOption.optionType === 'text'"
        :key="index"
        class="control"
        :class="{ 'hasText': otherIsSelect }"
        @click="other !== '' ? otherIsSelect = !otherIsSelect : ''"
      >
        <b-input
          v-model.trim="other"
          v-validate="{ required: Boolean(field.required) }"
          :data-vv-as="field.title"
          :name="name"
          :placeholder="fieldOption.title"
          :class="{ 'hasText': otherIsSelect }"
        ></b-input>
      </div>
    </template>
  </b-field>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
</style>
